var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa fa-lg pointer",class:'fa-' + _vm.icon,attrs:{"title":_vm.uLang('app.regenerate_invoice')},on:{"click":function($event){$event.preventDefault();return _vm.regenerateInvoice.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }